//#region Imports
import { shouldPolyfill as shouldPolyfillListformat } from "@formatjs/intl-listformat/should-polyfill";
import { shouldPolyfill as shouldPolyfillNumberformat } from "@formatjs/intl-numberformat/should-polyfill";
import { shouldPolyfill as shouldPolyfillPluralrules } from "@formatjs/intl-pluralrules/should-polyfill";
import { shouldPolyfill as shouldPolyfillLocale } from "@formatjs/intl-locale/should-polyfill";
import { shouldPolyfill as shouldPolyfillGetCanonicalLocale } from "@formatjs/intl-getcanonicallocales/should-polyfill";
import { shouldPolyfill as shouldPolyfillDurationFormat } from "@formatjs/intl-durationformat/should-polyfill";
//#endregion

export const SHOULD_POLYFILL_INTL =
  shouldPolyfillListformat() ||
  shouldPolyfillNumberformat() ||
  shouldPolyfillPluralrules() ||
  shouldPolyfillLocale() ||
  shouldPolyfillGetCanonicalLocale() ||
  shouldPolyfillDurationFormat();

export async function prepareI18nDependencies(): Promise<void> {
  if (SHOULD_POLYFILL_INTL) {
    await import("./imports/with-polyfills/en");
  }
}
